import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { format } from "date-fns";
import { pl } from "react-day-picker/locale";
import { ChevronDownIcon } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import type { ControllerProps, FieldPath, FieldValues } from "react-hook-form";

export function DateFormField<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  label,
  ...props
}: Omit<ControllerProps<TFieldValues, TName>, "render"> & { label?: string }) {
  return (
    <FormField
      {...props}
      render={({ field: { value, ...field } }) => {
        const dateValue = value ? new Date(value) : undefined;

        return (
          <FormItem>
            <FormLabel>{label ?? "Data"}</FormLabel>
            <FormControl>
              <Popover>
                <PopoverTrigger asChild>
                  <Button
                    variant={"outline"}
                    data-empty={!dateValue}
                    className="data-[empty=true]:text-muted-foreground w-full justify-between text-left font-normal"
                  >
                    {dateValue ? (
                      format(dateValue, "PPP", {
                        locale: pl,
                      })
                    ) : (
                      <span>Wybierz date</span>
                    )}
                    <ChevronDownIcon data-icon="inline-end" />
                  </Button>
                </PopoverTrigger>
                <PopoverContent className="w-auto p-0" align="start">
                  <Calendar
                    mode="single"
                    locale={pl}
                    selected={dateValue}
                    onSelect={(date) => {
                      let dateToSet: string | undefined = undefined;
                      if (date) {
                        // FIXME: set to midday for avoiding time zone confusion
                        date.setHours(12);
                        dateToSet = date.toISOString();
                      }
                      field.onChange(dateToSet);
                    }}
                    defaultMonth={dateValue}
                  />
                </PopoverContent>
              </Popover>
            </FormControl>
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
}
